import React, { useEffect, useState } from 'react';
import { useCookies, withCookies } from 'react-cookie';
import { useNavigate, useParams } from 'react-router-dom';
import Header from '../components/Header';
import AvatarCircle from '../components/AvatarCircle';
import UserList from '../components/UserList';
import { useAuthCheck } from '../util/utils';

const ProfileComponent = ({ api }) => {

    const navigate = useNavigate()
    const { username } = useParams()

    const [followers, setFollowers] = useState([])
    const [following, setFollowing] = useState([])

    const [followFromUser, setFollowFromUser] = useState({})

    const [activeTab, setActiveTab] = useState('details');
    const [unfollowWindowOpen, setUnfollowWindowOpen] = useState(false);
    const [cookies] = useCookies([])
    const [userInfo, setUserInfo] = useState({
        id: '',
        name: '',
        username: '',
        birthday: '',
        private: true,
        followStatus: null
    });

    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };

    const handleFollowClick = async () => {
        if (userInfo.followStatus === FollowStatus.NOT_FOLLOWING) {
            try {
                const resp = await api().sendFollowRequest(cookies.token, userInfo.id)
                if (resp.status === 200) {
                    setUserInfo((prev) => ({
                        ...prev,
                        followStatus: resp.data.status
                    }));
                }
            } catch (error) {

            }
        } else if (userInfo.followStatus === FollowStatus.ACCEPTED) {
            setUnfollowWindowOpen(true)
        }
    };

    const fetchFollowFromUser = async () => {
        if (cookies.token && userInfo.id) {
            try {
                const resp = await api().listFollowFromUser(cookies.token, userInfo.id)
                if (resp.status === 200) {
                    setFollowFromUser((prev) => ({
                        ...prev,
                        followId: resp.data._id,
                        status: resp.data.status
                    }))
                }
            } catch (error) {

            }
        }
    };

    const getFollowLabel = (status, isPrivate) => {
        switch (status) {
            case FollowStatus.PENDING:
                return "Requested"
            case FollowStatus.NOT_FOLLOWING:
                return (isPrivate ? "Request to " : "") + "Follow"
            case FollowStatus.ACCEPTED:
                return "Following"
            default:
            case FollowStatus.NOT_FOLLOWING:
                return "Follow"
        }
    }

    const getBirthday = () => {
        if (userInfo.private) {
            if (userInfo.followStatus == FollowStatus.ACCEPTED) {
                return `\u{1F382} ${userInfo.birthday}`
            } else {
                return "This user is private"
            }
        } else {
            return `\u{1F382} ${userInfo.birthday}`
        }
    }

    const FollowStatus = {
        NOT_FOLLOWING: "NOT_FOLLOWING",
        PENDING: "PENDING",
        ACCEPTED: "ACCEPTED",
        IGNORED: "IGNORED",
        BLOCKED: "BLOCKED"
    };

    const mapUser = (user) => ({
        username: user.username,
        name: `${user.firstName} ${user.lastName}`,
        caption: user.username
    })

    useAuthCheck()

    const unfollow = async () => {
        let token = cookies.token
        if (!token) return;
        try {
            const resp = await api().unfollow(token, userInfo.id)
            if (resp.status === 200) {
                window.location.reload();
            }
        } catch (e) {
            console.log(e)
        }
    }

    const handleAcceptFollow = async () => {
        try {
            const resp = await api().performFollowAction(cookies.token, followFromUser.followId, "accept")
            window.location.reload();
        } catch (e) {
        }
    }

    const handleDeclineFollow = async () => {
  try {
      const resp = await api().performFollowAction(cookies.token, followFromUser.followId, "decline")
      window.location.reload();

    } catch (e) {
      
    }
    }

    useEffect(() => {
        (async () => {
            try {
                let resp = await api().getUser(cookies.token, username)
                if (resp.status === 200) {
                    setUserInfo((prev) => ({
                        ...prev,
                        id: resp.data.id,
                        name: `${resp.data.firstName} ${resp.data.lastName}`,
                        username: resp.data.username,
                        private: resp.data.isPrivate,
                        birthday: `${resp.data.birthMonth ? `${resp.data.birthMonth}/${resp.data.birthDay}` : ""}`,
                        followStatus: resp.data.followStatus ?? "NOT_FOLLOWING"
                    }));
                }
            } catch (e) {
                if (e.response.status === 404) {
                    navigate("/404")
                }
            }
        })()
    }, [])

    useEffect(() => {
        (async () => {
            if (userInfo.id && userInfo.followStatus == "ACCEPTED") {
                try {
                    const resp = await api().listFollowersForUser(cookies.token, userInfo.id)
                    if (resp.status === 200) {
                        setFollowers(
                            resp.data.map(mapUser)
                        )
                    }
                } catch (e) {

                }
            }
        })()
    }, [userInfo])

    useEffect(() => {
        (async () => {
            if (userInfo.id && userInfo.followStatus == "ACCEPTED") {
                try {
                    const resp = await api().listFollowingForUser(cookies.token, userInfo.id)
                    if (resp.status === 200) {
                        setFollowing(
                            resp.data.map(mapUser)
                        )
                    }
                } catch (e) {
                    console.log(e)
                }
            }
        })()
    }, [userInfo])

    useEffect(() => {
        if (cookies.token && userInfo.id) fetchFollowFromUser()
    }, [userInfo, cookies])

    return (
        <div className="bg-gradient-to-b from-blue-400 to-green-700 min-h-screen flex flex-col pt-20 items-center py-8">
            <div className="bg-white shadow-lg rounded-lg w-full max-w-md p-6">
                {/* Profile Picture */}
                <div className="flex flex-col items-center">
                    {followFromUser && followFromUser.status == FollowStatus.PENDING && (
                        <div className="mb-4 w-full bg-yellow-100 border border-yellow-400 text-yellow-800 px-4 py-3 rounded">
                            <p className="text-center font-medium">{`${userInfo.name} wants to follow you.`}</p>
                            <div className="mt-2 flex justify-center space-x-4">
                                <button
                                    onClick={handleAcceptFollow}
                                    className="px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600 transition"
                                >
                                    Accept
                                </button>
                                <button
                                    onClick={handleDeclineFollow}
                                    className="px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition"
                                >
                                    Decline
                                </button>
                            </div>
                        </div>
                    )}
                    <div className="w-24 h-24 rounded-full bg-gray-200 flex items-center justify-center overflow-hidden">
                        <AvatarCircle letters={userInfo.name} />
                    </div>
                    <h2 className="text-2xl font-semibold mt-4">{userInfo.name}</h2>
                    <h4>{userInfo.username}</h4>
                </div>

                {/* Buttons */}
                <div className="mt-4 flex justify-center">
                    <button
                        className={`px-6 py-2 text-white font-semibold rounded-lg focus:outline-none transition duration-300 
              ${userInfo.followStatus === FollowStatus.NOT_FOLLOWING
                                ? "bg-blue-500 hover:bg-blue-600"
                                : userInfo.followStatus === FollowStatus.PENDING
                                    ? "bg-yellow-500 cursor-not-allowed"
                                    : "bg-green-500 hover:bg-green-600"
                            }
            `}
                        onClick={handleFollowClick}
                        disabled={userInfo.followStatus === FollowStatus.PENDING}
                    >
                        {getFollowLabel(userInfo.followStatus, userInfo.private)}
                    </button>
                </div>
                {followFromUser && followFromUser.status == "ACCEPTED" && <div className="flex flex-col items-center mt-4">{
                    "Follows you"
                }</div>}


                <div className="max-w-4xl mx-auto p-4">
                    {/* Tab Navigation */}
                    <div className="flex border-b">
                        <button
                            onClick={() => handleTabClick('details')}
                            className={`py-2 px-4 ${activeTab === 'details' ? 'border-b-2 border-blue-500' : ''}`}
                        >
                            Profile
                        </button>
                        {userInfo.followStatus == FollowStatus.ACCEPTED &&
                            <button
                                onClick={() => handleTabClick('followed')}
                                className={`py-2 px-4 ${activeTab === 'followed' ? 'border-b-2 border-blue-500' : ''}`}
                            >
                                Following
                            </button>
                        }
                        {userInfo.followStatus == FollowStatus.ACCEPTED &&

                            <button
                                onClick={() => handleTabClick('followers')}
                                className={`py-2 px-4 ${activeTab === 'followers' ? 'border-b-2 border-blue-500' : ''}`}
                            >
                                Followers
                            </button>
                        }

                    </div>
                </div>

                {activeTab === 'details' && (
                    < div className="mt-6">
                        <h3 className="text-lg font-semibold text-gray-800">Birthday</h3>
                        <h4 className='text-lg font-bold'>{getBirthday()}</h4>
                        <p className="mt-2 text-gray-700">{userInfo.bio}</p>
                    </div>
                )}

                {activeTab === 'followed' && (
                    <div>
                        <h2 className="text-lg font-semibold text-gray-800">Following</h2>
                        {following.length === 0 ? (
                            <p>{userInfo.username} does not follow anyone</p>
                        ) : (
                            <UserList users={following} size={"size-12"} textColor={"text-gray-800"} />
                        )}
                    </div>
                )}

                {activeTab === 'followers' && (
                    <div>
                        <h2 className="text-lg font-semibold text-gray-800">Followers</h2>
                        {followers.length === 0 ? (
                            <p>{userInfo.username} does not have any followers</p>
                        ) : (
                            <UserList users={followers} size={"size-12"} textColor={"text-gray-800"} />
                        )}
                    </div>
                )}

                {unfollowWindowOpen && (
                    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
                        <div className="bg-white p-6 rounded-lg shadow-lg w-80">
                            <h3 className="text-xl font-medium mb-2">{`Unfollow ${userInfo.username}?`}</h3>

                            {userInfo.private && <h3 className="text-l font-medium mb-4">{`${userInfo.name} is private, so you'll have to request to follow them again if you change your mind`}</h3>}

                            {/* Buttons */}
                            <div className="flex justify-end mt-4 space-x-2">
                                <button
                                    className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
                                    onClick={() => unfollow()}
                                >
                                    Unfollow
                                </button>
                                <button
                                    className="px-4 py-2 bg-gray-400 text-white rounded-lg hover:bg-gray-500"
                                    onClick={() => setUnfollowWindowOpen(false)}
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                )}

            </div>
        </div >
    );
};


const Profile = withCookies(({ api }) => (
    <div>
        <Header api={api} />
        <ProfileComponent api={api} />
    </div>
))


export default Profile;
